import { AxiosError } from 'axios';
import { GET_GROUP_EXAM_REGISTRATION_CHECK_ELIGIBILITY } from '../../constants/apiUrls';
import { GET_GROUP_EXAM_REGISTRATION_ELIGIBILITY_QUERY_KEY } from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import { GenericErrorResponse } from '../typings';
import {
  ExamRegistrationExist,
  ExamRegistrationType,
  ExamType,
} from '../../api/candidate/exam/model';
import { useCustomQuery } from '../utils/useCustomQuery';

export interface GetEligibilityCheckingResponse {
  organisationName: string;
  examRegistrationType: ExamRegistrationType;
  draft: ExamRegistrationExist;
}

interface Input {
  examType: ExamType;
  token?: string | null;
  onSuccess?: (data: GetEligibilityCheckingResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetEligibilityChecking = ({
  onSuccess,
  onError,
  examType,
  token = null,
}: Input) => {
  const getEligibilityChecking = async () => {
    const res = await axiosClient.get<GetEligibilityCheckingResponse>(
      GET_GROUP_EXAM_REGISTRATION_CHECK_ELIGIBILITY(examType, token)
    );
    return res.data;
  };
  return useCustomQuery(
    [GET_GROUP_EXAM_REGISTRATION_ELIGIBILITY_QUERY_KEY],
    getEligibilityChecking,
    {
      onSuccess,
      onError,
    },
    true,
    false
  );
};
